import { SUPABASE } from 'drapcode-constant';

export const supabaseActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign Up',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign In via Email & Password',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign Out',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Fetch User',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Update User',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'authorizeWithExternalDataSource',
    label: 'Supabase: Authorize Using API',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Change Password',
  //   type: 'AUTH',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'AUTH',
  //     },
  //   ],
  // },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Forgot Password',
  //   type: 'AUTH',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'AUTH',
  //     },
  //   ],
  // },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Confirm Password',
  //   type: 'AUTH',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'AUTH',
  //     },
  //   ],
  // },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Create Tenant',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'TENANT',
  //     },
  //   ],
  // },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Assign Current User To Tenant',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'AUTH',
  //     },
  //   ],
  // },
  // {
  //   name: 'sendDataToExternalSource',
  //   label: 'Supabase: Switch Tenant',
  //   args: [
  //     {
  //       name: 'confirmationMessage',
  //       label: 'Alert Message',
  //       type: 'text',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message (Optional)',
  //       type: 'text',
  //       value: '',
  //       optional: true,
  //     },
  //     {
  //       name: 'errorMessage',
  //       label: 'Error Message (Optional)',
  //       type: 'text',
  //       value: '',
  //       optional: true,
  //     },
  //     {
  //       name: 'skipPageReload',
  //       label: 'Skip Page Reload',
  //       type: 'boolean',
  //       value: true,
  //       custom: [],
  //     },
  //     {
  //       name: 'sessionKey',
  //       label: 'Session Key',
  //       type: 'text',
  //       value: 'TENANT',
  //     },
  //   ],
  // },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Send Data To API',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  // {
  //   name: 'sendDataToExternalSourceAndFileDownload',
  //   label: 'Supabase: Download File Using API',
  //   source: SUPABASE,
  //   args: [
  //     {
  //       name: 'webhookId',
  //       label: 'External API',
  //       type: 'dropdown',
  //       optionsType: 'dsSupabase',
  //       value: '',
  //     },
  //     {
  //       name: 'successMessage',
  //       label: 'Success Message',
  //       type: 'text',
  //       value: '',
  //     },
  //   ],
  // },
];
